//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ModalAcceptTerms',
  data() {
    return {
      title: 'New Terms and Conditions',
      content: this.$t(`We have updated the Terms and Conditions. Click here, read them carefully and accept them to be able to deposit and continue playing on our page.`),
      button_text: 'View the new version of the Terms and Conditions',
      isOpen: false,
      closeModal: false
    }
  },
  watch: {
    isOpen: function(){
      if (this.isOpen) {
        this.$store.commit('addModal', this.$options.name)
      } else {
        this.$store.commit('removeModal', this.$options.name)
      }
    }
  },
  methods: {
    preventClose(event) {
      if (this.isOpen) {
        event.cancel()
      }      
    },    
    checkOpenModal() {
      for (let i = 0; i < this.$store.state.openedModals.length; i++) {
        if (this.$store.state.openedModals[i] !== this.$options.name) {
          return false
        }
      }
      return true
    },    
    opened() {
      this.isOpen = true;
    },    
    beforeOpen (event) {
      console.info(event)
      window.dispatchEvent(new Event('resize'));

      if (_.get(event, 'params')) {
        this.title = _.get(event, 'params.title', '')
        this.content = _.get(event, 'params.content', '')        
      }

    },
    close() {
      this.isOpen = false;       
      this.$modal.hide('modal-accept-terms')
      this.$router.push({path: '/ayuda/terminos-y-condiciones/'})
    },
    async submit() {}
  }
}
